import { useSelector } from "react-redux";

// Costura unica de permisos de facturacion masiva. Hoy deriva del rol actual
// (mismos roles que ya acceden a la facturacion de planes); no agrega permisos
// nuevos. Cuando llegue el modelo RBAC, solo cambia este hook.
const ROLES_FACTURACION = ["SUPER_ADMIN", "ADMIN"];

export default function usePermisoFacturacion() {
  const rol = useSelector((state) => state.auth.user?.rol);
  const acceso = ROLES_FACTURACION.includes(rol);
  return {
    puedeVer: acceso,
    puedeFacturar: acceso,
    puedeEditarCantidad: acceso,
    puedeReintentar: acceso,
    puedeNotificar: acceso,
  };
}
